import axiosService from './axiosService';

export const getCalendarDays = (userId, year, month, zoneOffset) => {
    let params = "";
    params = params + "&year=" + encodeURIComponent(year);
    params = params + "&month=" + encodeURIComponent(month);
    params = params + "&zoneOffset=" + encodeURIComponent(zoneOffset);
    return axiosService.get("/calendar?userId=" + userId + params);
}
